<template>
  <LabelWrapper :label="label" :widelabel="widelabel" :smlabel="smlabel">
    <FText
      :disabled="disabled"
      :value="stringValue"
      @keydown="(v) => onKeydown(v)"
      @input="(v) => onInput(v)"
    />
  </LabelWrapper>
</template>

<script>
import LabelWrapper from "./wrappers/LabelWrapper";
import FText from "./items/FText";

const NAV_KEYS = new Set([
  "Backspace",
  "Delete",
  "Tab",
  "Escape",
  "Enter",
  "ArrowLeft",
  "ArrowRight",
  "ArrowUp",
  "ArrowDown",
  "Home",
  "End",
]);

export default {
  props: {
    disabled: Boolean,
    widelabel: Boolean,
    smlabel: Boolean,
    label: String,
    value: [String, Number],
    alphanumericOnly: Boolean,
    /** Allow letters, numbers, "-" and "_"; convert spaces to "-". */
    filenameSafe: Boolean,
  },
  components: {
    LabelWrapper,
    FText,
  },
  computed: {
    stringValue() {
      if (!this.value) return "";
      return `${this.value}`;
    },
  },
  methods: {
    sanitizeFilename(value) {
      return String(value || "")
        .replace(/ /g, "-")
        .replace(/[^a-zA-Z0-9_-]/g, "");
    },
    onInput(value) {
      if (this.filenameSafe) {
        this.$emit("input", this.sanitizeFilename(value));
        return;
      }
      if (this.alphanumericOnly) {
        this.$emit("input", String(value || "").replace(/[^a-zA-Z0-9 ]/g, ""));
        return;
      }
      this.$emit("input", value);
    },
    onKeydown(event) {
      if (!this.alphanumericOnly && !this.filenameSafe) {
        this.$emit("keydown", event);
        return;
      }

      if (event.ctrlKey || event.metaKey || event.altKey || NAV_KEYS.has(event.key)) {
        this.$emit("keydown", event);
        return;
      }

      if (this.filenameSafe) {
        if (event.key === " " || event.key === "Spacebar") {
          event.preventDefault();
          this.insertAtCursor("-", event.target);
          return;
        }
        if (event.key.length === 1 && /[^a-zA-Z0-9_-]/.test(event.key)) {
          event.preventDefault();
          return;
        }
      } else if (this.alphanumericOnly) {
        if (event.key.length === 1 && /[^a-zA-Z0-9]/.test(event.key)) {
          event.preventDefault();
          return;
        }
      }

      this.$emit("keydown", event);
    },
    insertAtCursor(char, inputEl) {
      const current = this.stringValue;
      if (!inputEl || typeof inputEl.selectionStart !== "number") {
        this.$emit("input", this.sanitizeFilename(`${current}${char}`));
        return;
      }

      const start = inputEl.selectionStart;
      const end = inputEl.selectionEnd;
      const next = this.sanitizeFilename(`${current.slice(0, start)}${char}${current.slice(end)}`);
      this.$emit("input", next);
      this.$nextTick(() => {
        const pos = Math.min(start + char.length, next.length);
        if (typeof inputEl.setSelectionRange === "function") {
          inputEl.setSelectionRange(pos, pos);
        }
      });
    },
  },
};
</script>
